import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary, ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CardComposerLabelsListProps } from './CardComposerLabelsList';

export const LazyCardComposerLabelsList: FunctionComponent<CardComposerLabelsListProps> = (
  props,
) => {
  const CardComposerLabelsList = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-composer-labels-list" */ './CardComposerLabelsList'
      ),
    { namedImport: 'CardComposerLabelsList' },
  );
  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-workflowers', feature: 'Labels Popover' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <CardComposerLabelsList {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};

// Used to populate PopOver.displayType, which is then used for query selectors.
LazyCardComposerLabelsList.displayName = 'LazyCardComposerLabelsList';
